<template>
  <Modal v-model="show" :mask-closable="false" @on-ok="save" :loading="loading" :width="800">
    <div slot="header" class="modal-header">生活费用设置</div>
    <div style="line-height:3;">客户：</div>
    <div class="mb32">
      <Checkbox v-model="datas['lengShui'].isShow" @on-change="showPice">冷水</Checkbox>
      <Checkbox v-model="datas['dian'].isShow" @on-change="showPice">电</Checkbox>
      <Checkbox v-model="datas['ranQi'].isShow" @on-change="showPice">燃气</Checkbox>
      <Checkbox v-model="datas['reShui'].isShow" @on-change="showPice">热水</Checkbox>
      <Checkbox v-model="datas['zhongShui'].isShow" @on-change="showPice">中水</Checkbox>
    </div>
    <div  class="nobeforered">
      <div v-if="!isShowPic">
        <Row
          v-for="(item,key) in datas"
          :gutter="24"
          :key="'keyA'+key"
          class="mb8"
          v-if="item.isShow"
        >
          <Form :model="item" label-position="left" :ref="'form'+key" :rules="formRules">
            <Col span="6">
              <FormItem
                prop="isIntelligent"
                class="notip inline-b"
                :label="item.deviceName+''"
                :label-width="50"
              >
                <Select v-model="item.isIntelligent" size="small" placeholder="是否智能">
                  <!--                  <Option value="">请选择</Option>-->
                  <Option
                    v-for="(item,index) in isIntelligentList"
                    :value="item.value"
                    :key="'keyB'+index"
                  >{{item.text}}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="7">
              <FormItem prop="unitPrice" class="notip inline-b" label="单价" :label-width="45">
                <!--              <InputNumber  v-model="item.unitPrice" size="small" class="formwidth"  :max=100 :min=1-->
                <!--                            ></InputNumber >-->
                <common-input
                  v-model="item.unitPrice"
                  size="small"
                  class="formwidth"
                  :min="0"
                  :limit="2"
                ></common-input>
              </FormItem>

              <span class="unit">{{unitMap[item.deviceType]}}</span>
            </Col>
            <Col span="4">
              <FormItem prop="payType" class="notip" :label-width="0">
                <Select
                  v-model="item.payType"
                  size="small"
                  placeholder="付费类型"
                  @on-change="changePayType(item)"
                >
                  <!--                                    <Option value="">请选择</Option>-->
                  <Option
                    v-for="(item,index) in typeList"
                    :value="item.value"
                    :key="'keyB'+index"
                  >{{item.text}}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="7" v-if="item.payType===1">
              <FormItem prop="readCycle" class="notip inline-b" :label-width="80" label="抄表周期">
                <!--<Input v-model="item.readCycle" size="small" class="inline-b formwidth">-->
                <!--</Input>-->
                <Select
                  v-model="item.readCycle"
                  class="inline-b formwidth"
                  :transfer="true"
                  size="small"
                >
                  <Option
                    v-for="item in readCycleList"
                    :value="item.value"
                    :key="item.value"
                  >{{item.text}}</Option>
                </Select>
              </FormItem>
              <span class="unit">号/月</span>
            </Col>
          </Form>
        </Row>
      </div>
      <div v-if="isShowPic" align="center">
        <img src="@/assets/group.png" width="58px" height="70px" style="margin-top:30px" />
        <div style="color: #D0D0D0;font-size: 12px">请选择费用项并设置</div>
      </div>
    </div>

    <div style="line-height:3;">业主：</div>
    <div class="mb32">
      <Checkbox v-model="ownerdatas['lengShui'].isShow" @on-change="showOwnerPice">冷水</Checkbox>
      <Checkbox v-model="ownerdatas['dian'].isShow" @on-change="showOwnerPice">电</Checkbox>
      <Checkbox v-model="ownerdatas['ranQi'].isShow" @on-change="showOwnerPice">燃气</Checkbox>
      <Checkbox v-model="ownerdatas['reShui'].isShow" @on-change="showOwnerPice">热水</Checkbox>
      <Checkbox v-model="ownerdatas['zhongShui'].isShow" @on-change="showOwnerPice">中水</Checkbox>
    </div>
    <div  class="nobeforered">
      <div v-if="!ownerIsShowPic">
        <Row
          v-for="(item,key) in ownerdatas"
          :gutter="24"
          :key="'keyA'+key"
          class="mb8"
          v-if="item.isShow"
        >
          <Form :model="item" label-position="left" :ref="'form'+key" :rules="formRules">
            <Col span="6">
              <FormItem
                prop="isIntelligent"
                class="notip inline-b"
                :label="item.deviceName+''"
                :label-width="50"
              >
                <Select v-model="item.isIntelligent" size="small" placeholder="是否智能">
                  <!--                  <Option value="">请选择</Option>-->
                  <Option
                    v-for="(item,index) in isIntelligentList"
                    :value="item.value"
                    :key="'keyB'+index"
                  >{{item.text}}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="7">
              <FormItem prop="unitPrice" class="notip inline-b" label="单价" :label-width="45">
                <!--              <InputNumber  v-model="item.unitPrice" size="small" class="formwidth"  :max=100 :min=1-->
                <!--                            ></InputNumber >-->
                <common-input
                  v-model="item.unitPrice"
                  size="small"
                  class="formwidth"
                  :min="0"
                  :limit="2"
                ></common-input>
              </FormItem>

              <span class="unit">{{unitMap[item.deviceType]}}</span>
            </Col>
            <Col span="4">
              <FormItem prop="payType" class="notip" :label-width="0">
                <Select
                  v-model="item.payType"
                  size="small"
                  placeholder="付费类型"
                  @on-change="changePayType(item)"
                >
                  <!--                                    <Option value="">请选择</Option>-->
                  <Option
                    v-for="(item,index) in typeList"
                    :value="item.value"
                    :key="'keyB'+index"
                  >{{item.text}}</Option>
                </Select>
              </FormItem>
            </Col>
            <Col span="7" v-if="item.payType===1">
              <FormItem prop="readCycle" class="notip inline-b" :label-width="80" label="抄表周期">
                <!--<Input v-model="item.readCycle" size="small" class="inline-b formwidth">-->
                <!--</Input>-->
                <Select
                  v-model="item.readCycle"
                  class="inline-b formwidth"
                  :transfer="true"
                  size="small"
                >
                  <Option
                    v-for="item in readCycleList"
                    :value="item.value"
                    :key="item.value"
                  >{{item.text}}</Option>
                </Select>
              </FormItem>
              <span class="unit">号/月</span>
            </Col>
          </Form>
        </Row>
      </div>
      <div v-if="ownerIsShowPic" align="center">
        <img src="@/assets/group.png" width="58px" height="70px" style="margin-top:30px" />
        <div style="color: #D0D0D0;font-size: 12px">请选择费用项并设置</div>
      </div>
    </div>

    <!--        <Tabs v-model="curTag" :animated="false">-->
    <!--            <TabPane label="水费用标准设置" name="water">-->
    <!--                <form-list :payTypeList="payTypeList" :readCycleList="readCycleList" :setings="waterSettings" :meter-type="1" ref="water"></form-list>-->
    <!--            </TabPane>-->
    <!--            <TabPane label="电费用标准设置" name="watt">-->
    <!--                <form-list :payTypeList="payTypeList" :readCycleList="readCycleList" :setings="wattSettings" :meter-type="0" ref="watt"></form-list>-->
    <!--            </TabPane>-->
    <!--        </Tabs>-->
  </Modal>
</template>

<script type="text/ecmascript-6">
import FormList from "./FormItem";
import { setData, settingsGet, settingsSave } from "api/waterAndElectricity";
import CommonInput from "../../../../components/CommonInput";
import { deepClone } from '@/utils/format'
const setting = {
  lengShui: {
    deviceName: "冷水",
    deviceType: 0,
    unitPrice: null,
    payType: null,
    readCycle: null,
    isIntelligent: null,
    isShow: false
  },
  dian: {
    deviceName: "电",
    deviceType: 1,
    unitPrice: null,
    payType: null,
    readCycle: null,
    isIntelligent: null,
    isShow: false
  },
  ranQi: {
    deviceName: "燃气",
    deviceType: 2,
    unitPrice: null,
    payType: null,
    readCycle: null,
    isIntelligent: null,
    isShow: false
  },
  reShui: {
    deviceName: "热水",
    deviceType: 3,
    unitPrice: null,
    payType: null,
    readCycle: null,
    isIntelligent: null,
    isShow: false
  },
  zhongShui: {
    deviceName: "中水",
    deviceType: 4,
    unitPrice: null,
    payType: null,
    readCycle: null,
    isIntelligent: null,
    isShow: false
  }
};

export default {
  name: "setModal",
  props: {
    n: {
      type: Number,
      default: null
    },
    projectFid: {
      type: String,
      default: ""
    }
  },
  components: {
    FormList,
    CommonInput
  },
  watch: {
    n(val) {
      this.clearData();
      this.show = true;
      this.setGet(this.projectFid);
      // this.curTag = 'water';
    }
  },

  data() {
    return {
      formRules: {
        isIntelligent: [
          {
            required: true,
            message: " ",
            trigger: "blur",
            validator: this.validateNumber
          }
        ],
        unitPrice: [
          {
            required: true,
            message: " ",
            trigger: "blur",
            validator: this.validateNumber
          }
        ],
        payType: [
          {
            required: true,
            message: " ",
            trigger: "blur",
            validator: this.validateNumber
          }
        ],
        readCycle: [
          {
            required: true,
            message: " ",
            trigger: "blur",
            validator: this.validateNumber
          }
        ]
      },
      typeList: [{ text: "预付费", value: 0 }, { text: "后付费", value: 1 }],
      isIntelligentList: [
        { text: "智能表", value: 0 },
        { text: "非智能表", value: 1 }
      ],
      unitMap: {
        "0": "元/吨",
        "1": "元/度",
        "2": "元/立方",
        "3": "元/吨",
        "4": "元/吨"
      },

      datas: deepClone(setting),
      ownerdatas: deepClone(setting),
      rules: {},
      show: false,
      curTag: "water",
      payTypeList: [],
      readCycleList: [],
      waterSettings: {}, //水
      wattSettings: {}, //电
      loading: true,
      isShowPic: false,
      ownerIsShowPic: false
    };
  },
  created() {
    this.initData();
  },
  methods: {
    clearData() {
      this.datas = deepClone(setting);
      this.ownerdatas = deepClone(setting);
    },
    changePayType(item) {
      item.readCycle = null;
    },
    validateNumber(rule, value, callback) {
      let pattern = /^(-?\d+)(\.\d+)?$/;
      if (!pattern.test(value)) {
        callback(new Error(" "));
      }
      callback();
    },
    initData() {
      setData().then(res => {
        this.payTypeList = res.data.payTypeList;
        this.readCycleList = res.data.readCycleList;
      });
    },
    setGet(id) {
      settingsGet({ projectFid: id }).then(res => {
        if(res.data){
          res = res.data;
        }else{
          this.isShowPic = true;
          this.ownerIsShowPic = true;
        }
        if(res.cusmoter){
          if (
            !res.cusmoter.dian &&
            !res.cusmoter.lengShui &&
            !res.cusmoter.ranQi &&
            !res.cusmoter.reShui &&
            !res.cusmoter.zhongShui
          ) {
            this.isShowPic = true;
            return;
          }
          if (res.cusmoter.dian) {
            this.datas.dian =  { ...this.datas.dian, ...res.cusmoter.dian, isShow: true };
          }
          if (res.cusmoter.lengShui) {
            this.datas.lengShui = { ...this.datas.lengShui, ...res.cusmoter.lengShui, isShow: true };
         }
          if (res.cusmoter.ranQi) {
            this.datas.ranQi = { ...this.datas.ranQi, ...res.cusmoter.ranQi, isShow: true };
          }
          if (res.cusmoter.reShui) {
            this.datas.reShui = { ...this.datas.reShui, ...res.cusmoter.reShui, isShow: true };
          }
          if (res.cusmoter.zhongShui) {
            this.datas.zhongShui = { ...this.datas.zhongShui, ...res.cusmoter.zhongShui, isShow: true };
          }
          this.isShowPic = false;
        }else {
          this.isShowPic = true;
        }

        if(res.owner){
          if (
            !res.owner.dian &&
            !res.owner.lengShui &&
            !res.owner.ranQi &&
            !res.owner.reShui &&
            !res.owner.zhongShui
          ) {
            this.ownerIsShowPic = true;
            return;
          }
            if (res.owner.dian) {
              this.ownerdatas.dian =  { ...this.ownerdatas.dian, ...res.owner.dian, isShow: true };
            }
            if (res.owner.lengShui) {
              this.ownerdatas.lengShui = { ...this.ownerdatas.lengShui,  ...res.owner.lengShui, isShow: true };
            }
            if (res.owner.ranQi) {
              this.ownerdatas.ranQi = { ...this.ownerdatas.ranQi,  ...res.owner.ranQi, isShow: true };
            }
            if (res.owner.reShui) {
              this.ownerdatas.reShui = { ...this.ownerdatas.reShui, ...res.owner.reShui, isShow: true };
            }
            if (res.owner.zhongShui) {
              this.ownerdatas.zhongShui = {  ...this.ownerdatas.zhongShui,  ...res.owner.zhongShui, isShow: true };
            }
            this.ownerIsShowPic = false;
        }else{
          this.ownerIsShowPic = true;
        }


      });
    },
    save() {
      if (Object.keys(this.$refs).length === 0) {
        this.show = false;
        return;
      }
      let validate = true;
      for (let key in this.$refs) {
        this.$refs[key] &&
          this.$refs[key].forEach(ele => {
            ele.validate(bool => {
              if (!bool) {
                validate = false;
              }
            });
          });
      }

      if (!validate) {
        this.changeLoading();
        return;
      }
      let saveData = {};
      for (let key1 in this.datas) {
        if (this.datas[key1].isShow) {
          saveData[key1] = this.datas[key1];
        }
      }
      let ownerSaveData = {};
      for (let key2 in this.ownerdatas) {
        if (this.ownerdatas[key2].isShow) {
          ownerSaveData[key2] = this.ownerdatas[key2];
        }
      }
      let params = {
        projectFid: this.projectFid,
        customerSettingsDto: saveData,
        ownerSettingsDto: ownerSaveData
      };
      settingsSave(params)
        .then(res => {
          this.$Message.success("保存成功");
          this.$emit("refresh");
        })
        .catch(error => {})
        .finally(() => {
          this.show = false;
        });
    },
    changeLoading() {
      this.loading = false;
      this.$nextTick(() => {
        this.loading = true;
      });
    },
    showPice() {
      if (
        this.datas["lengShui"].isShow ||
        this.datas["dian"].isShow ||
        this.datas["ranQi"].isShow ||
        this.datas["reShui"].isShow ||
        this.datas["zhongShui"].isShow
      ) {
        this.isShowPic = false;
      } else {
        this.isShowPic = true;
      }

    },
    showOwnerPice(){
        if (
          this.ownerdatas["lengShui"].isShow ||
          this.ownerdatas["dian"].isShow ||
          this.ownerdatas["ranQi"].isShow ||
          this.ownerdatas["reShui"].isShow ||
          this.ownerdatas["zhongShui"].isShow
        ) {
          this.ownerIsShowPic = false;
        } else {
          this.ownerIsShowPic = true;
        }
    }
  }
};
</script>
<style scoped>
.formwidth {
  width: 80px;
}

.unit {
  line-height: 32px;
}
</style>
